import { render, staticRenderFns } from "./e-tags-menu-actions.vue?vue&type=template&id=7d24e6c5&scoped=true&lang=pug"
import script from "./e-tags-menu-actions.vue?vue&type=script&lang=js"
export * from "./e-tags-menu-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d24e6c5",
  null
  
)

export default component.exports